<template>
  <router-view></router-view>
</template>

<script setup>
import 'vue3-toastify/dist/index.css';
import { useAppStore } from "@/store/appInfo.js";
import { onMounted } from 'vue';

const { getAppInfo } = useAppStore();

onMounted(async () => {
  try {
    await getAppInfo('slqw')
  } catch (error) {
    return error
  }
})
</script>
